<div class="modal-md order-settings">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate uppercase full-width text-align-center"
      id="modal-label"
    >
      Customization
    </h1>
    <button
      type="button"
      (click)="close()"
      class="btn btn-icon close"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body customization">
    @if (customizations.length > 0) {
      @if (isMaxQuantityReached) {
        <div>
          <p class="text-danger">
            Maximum available quantity is {{ availableQuantity }}
          </p>
        </div>
      }
      @for (customItem of customizations; track customItem; let idx = $index) {
        <div class="customization--item">
          @if (!hasVariations) {
            <div class="d-flex flex-vertical quantity-container">
              <label>QTY:</label>
              <input
                (change)="onQuantityChanged(customItem)"
                class="digit-input"
                type="number"
                digitOnly
                min="0"
                [(ngModel)]="customItem.custom_qty"
                [min]="customItem.custom_min_qty"
              />
              <span
                class="font-5 uppercase"
                [ngClass]="{ red: customItem.error }"
              >
                Min QTY: {{ customItem.custom_min_qty }}
              </span>
              <a
                (click)="removeCustomization(idx)"
                class="link link-underline color-red mt-4"
                >Remove</a
              >
            </div>
          }
          <div class="labels-container">
            @for (label of customItem.custom_text_fields; track label) {
              <div class="input-group">
                <label
                  >{{ label.label }} ({{ label.required ? 'REQUIRED, ' : ''
                  }}{{ label.max_char }} characters max)</label
                >
                <input
                  type="text"
                  [(ngModel)]="label.text"
                  [maxLength]="label.max_char"
                  (change)="onTexChanged(label)"
                />
                @if (label.error) {
                  <span class="text-danger uppercase">text is required</span>
                }
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div class="min-h-5rem">
        <p class="font-3 text-danger text-align-center">
          Customizations will be removed.
        </p>
      </div>
    }
  </div>
  <div class="modal-footer">
    <div
      class="d-flex buttons-container"
      [ngClass]="{
        'justify-content-between': canAddCustomization,
        'justify-content-end': !canAddCustomization,
      }"
    >
      @if (canAddCustomization) {
        <button (click)="addCustomization()" class="btn btn-outline-primary">
          Add Customization
        </button>
      }
      <button (click)="done()" class="btn btn-primary">OK</button>
    </div>
  </div>
</div>
